<template>
    <div class="ContactUs">
        <menuBox :step="4"></menuBox>
        <div class="about-box">
            <div>Hubungi kami</div>
            <p>Pilih bumbu kami untuk memberikan cita rasa unik pada masakan Anda dan menjadikan makanan Anda lebih istimewa.</p>
        </div>

        <div class="list-box">
            <div class="qa-box">
                <div class="title">Jadikan setiap hidangan sebagai petualangan rasa saat rempah-rempah kami membawa Anda ke hal yang tidak diketahui.</div>
                <p>Gunakan bumbu kami untuk menghidupkan hidangan Anda, membuat selera Anda menari, dan menjadikan setiap hidangan sebuah petualangan rasa. Biarkan rempah-rempah kami membawa Anda ke hal yang tidak diketahui bersama kami.</p>
                <div class="qa-item">
                    <div class="qa-title" @click="qa_1 = !qa_1">Jaminan kualitas sumber
                        <img src="../assets/contact-3.png" alt="">
                    </div>
                    <p v-if="qa_1">
                        Kami memilih bahan baku terbaik untuk memastikan kualitas produk yang unggul dan memberikan jaminan yang dapat diandalkan untuk masakan Anda.
                        <br> Mengikuti keahlian tradisional dan keahlian unik, setiap bumbu penuh dengan cita rasa kampung halaman yang kuat.
                        <br> Kontrol secara ketat setiap aspek proses produksi untuk memastikan keamanan dan kebersihan produk, membuat meja makan Anda lebih aman.
                    </p>
                </div>

                <div class="qa-item">
                    <div class="qa-title" @click="qa_2 = !qa_2">Terus berkreasi dan berinovasi
                        <img src="../assets/contact-3.png" alt="">
                    </div>
                    <p v-if="qa_2">
                        Kami terus mengembangkan produk baru untuk memenuhi beragam kebutuhan konsumen akan makanan lezat dan memimpin tren industri.（
                    </p>
                </div>

                <div class="qa-item">
                    <div class="qa-title" @click="qa_3 = !qa_3">Layanan profesional, layanan purna jual tanpa rasa khawatir
                        <img src="../assets/contact-3.png" alt="">
                    </div>
                    <p v-if="qa_3">
                        Kami menyediakan layanan pembelian terpadu, dan tim profesional kami akan memberi Anda saran pembelian, sehingga Anda dapat dengan mudah membuat jamuan keluarga yang lezat.
                        <br>
                        Kami menyediakan layanan purna jual yang komprehensif untuk menyelesaikan semua masalah selama pembelian dan penggunaan, sehingga Anda tidak perlu khawatir.
                    </p>
                </div>

            </div>
            <img src="../assets/contact-2.png" alt="">
        </div>

        <div class="kami-box">
            <div class="title">Hubungi kami dan bekerja bersama kami untuk membuat hidup lebih beraroma dan bahagia</div>
            <div class="sbtitle">Jika Anda memiliki pertanyaan tentang layanan atau pembelian, Anda dapat menemukan kami. Kami selalu online untuk memberi Anda layanan yang paling perhatian.</div>
            <div class="kami-list">
                <img src="../assets/contact-5.png" alt="">
                <div class="input-box">
                    <input type="text" placeholder="Nama" v-model="m_value_1">
                    <div class="input-item">
                        <input type="text" placeholder="Alamat email" v-model="m_value_2">
                        <input type="text" placeholder="Telepon" v-model="m_value_3">
                    </div>
                    <textarea class="textarea" name="" id="" v-model="m_value_4" cols="30" rows="10" placeholder="Teks Anda"></textarea>
                    <div class="btn" @click="Submit">Kirim</div>
                </div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            qa_1: false,
            qa_2: false,
            qa_3: false,
            m_value_1: '',
            m_value_2: '',
            m_value_3: '',
            m_value_4: '',
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        },
        Submit() {
            if (!this.m_value_1) {
                return alert('Nama tidak boleh kosong')
            } else if (!this.m_value_2) {
                return alert('Alamat email tidak boleh kosong')
            } else if (!this.m_value_3) {
                return alert('Telepon tidak boleh kosong')
            } else if (!this.m_value_4) {
                return alert('Teks Anda tidak boleh kosong')
            }
            alert('Sudah terkirim')
        }
    }
}
</script>
<style lang="less" scoped>
.about-box {
    height: 600px;
    background-image: url(../assets/contact-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px 360px;

    div {
        font-weight: bold;
        font-size: 32px;
        color: #FFFFFF;
    }

    p {
        font-weight: 400;
        font-size: 24px;
        color: #FFFFFF;
        margin-top: 20px;
    }
}

.list-box {
    padding: 150px 360px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    img {
        width: 460px;
    }

    .qa-box {
        width: 630px;

        .title {
            font-weight: bold;
            font-size: 36px;
            color: #333333;
        }

        p {
            font-weight: 400;
            font-size: 20px;
            color: #999999;
            margin-top: 18px;
        }

        .qa-item {
            margin-top: 24px;

            .qa-title {
                width: 492px;
                height: 68px;
                background: #FFA200;
                border-radius: 20px 20px 20px 20px;
                font-size: 14px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: space-evenly;

                img {
                    width: 26px;
                }
            }

            p {
                font-weight: 400;
                font-size: 18px;
                color: #999999;
            }
        }
    }
}

.kami-box {
    padding: 0px 360px;
    padding-bottom: 150px;

    .title {
        font-weight: bold;
        font-size: 42px;
        color: #252B42;
        text-align: center;
    }

    .sbtitle {
        font-weight: 400;
        font-size: 17px;
        color: #333215;
        margin-top: 18px;
        text-align: center;
    }

    .kami-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 90px;

        img {
            width: 501px;
        }

        .input-box {
            width: 560px;
        }
    }
}

input {
    width: 504px;
    height: 57px;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #ACACAC;
    padding: 0px 28px;
}

.input-item {
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: space-between;

    input {
        width: 200px;
    }
}

.textarea {
    margin-top: 30px;
    padding: 18px 28px;
    width: 508px;
    height: 50px;
}

.btn {
    width: 564px;
    height: 59px;
    background: #FFA200;
    border-radius: 34px 34px 34px 34px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    font-weight: 400;
    font-size: 18px;
    color: #FAFAFA;
    margin-top: 28px;
    cursor: pointer;
}
</style>
